var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.appraisalList.length
        ? _c("div", {
            staticClass: "appraisal-details",
            attrs: {
              id: "appraisal-list",
              name: "appraisal-list",
              appear: "",
              tag: "div",
            },
          })
        : _vm._e(),
      _vm._l(_vm.appraisalList, function (appraisalItem, i) {
        return _c(
          "div",
          {
            key: `${appraisalItem}-${i}`,
            staticClass: "padding-top",
            style: { "--i": i },
            attrs: { id: `item-${i}` },
          },
          [
            _c("AppraisalItem", {
              attrs: { appraisal: appraisalItem, pos: i },
            }),
          ],
          1
        )
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }